module.exports = __webpack_public_path__ + "static/media/chat_bubble_illustration.3e253040.svg";